export enum ProductType {
  Family = 'f',
  Group = 'g',
  Product = 'p',
}
